import { roundNumber } from "web_myplann/Shared/Utils/numberFormatters";

export const signedPercentageValueFormatter = new Intl.NumberFormat("cs-CZ", {
	signDisplay: "exceptZero",
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

export const normalizeChange = (
	change: number | null | undefined,
): number | null => {
	if (change == null) return null;

	const roundedChange = roundNumber(change);
	return Math.abs(roundedChange) <= 0.01 ? 0 : roundedChange;
};
